<div class="header">
  <spb-logo [routePath]="['/', HOME_PATH]"
            title="Lönsamhetskalkyl"/>
  <div>
    <spb-progress/>
  </div>
  <div [style.flex-grow]="1"></div>
  <spb-toggle-button/>
  @if (service.currentUser()) {
    <span>{{ service.currentUser()?.name }}</span>
    <button [style.margin-right.rem]="1" [matMenuTriggerFor]="menu"
            mat-icon-button>
      <mat-icon [style.margin-top.px]="1">menu</mat-icon>
    </button>
  }
</div>

<mat-menu #menu="matMenu">
  <button [routerLink]="[HOME_PATH]" mat-menu-item>
    <mat-icon>home</mat-icon>
    Startsida
  </button>
  <button [routerLink]="[HOME_PATH, GUIDE_PATH]" mat-menu-item>
    <mat-icon>signpost</mat-icon>
    Ny kalkyl
  </button>
  <button [routerLink]="[LIST_PATH]" mat-menu-item>
    <mat-icon>list</mat-icon>
    Kundhantering
  </button>
  @if (helper.isAdmin()) {
    <button [routerLink]="[SETTINGS_PATH]" mat-menu-item>
      <mat-icon>settings</mat-icon>
      Inställningar
    </button>
  }
  <mat-divider/>
  <button (click)="service.reset()" mat-menu-item>
    Logga ut
  </button>
</mat-menu>
